import type { ForwardRefExoticComponent, RefAttributes } from "react";

import type { BalanceBoosterMultiplierHandle } from "../BalanceBoosterMultiplier.types";
import type { UseBoosterCoreProps } from "../core/useBoosterCore";

import { BoosterVariant } from "./BoosterVariant.types";
import { RewardPlatformBoosterUI } from "./rewardPlatform";

/**
 * Variant component type with core props and optional className
 */
export type VariantComponentProps = UseBoosterCoreProps & {
  className?: string;
};

/**
 * A variant UI component, exposing a `BalanceBoosterMultiplierHandle` via ref
 */
export type VariantComponent = ForwardRefExoticComponent<
  VariantComponentProps & RefAttributes<BalanceBoosterMultiplierHandle>
>;

/**
 * Registry mapping variants to their UI components
 */
export const VARIANT_COMPONENTS: Record<BoosterVariant, VariantComponent> = {
  [BoosterVariant.REWARD_PLATFORM]: RewardPlatformBoosterUI,
  [BoosterVariant.DEFAULT]: RewardPlatformBoosterUI,
} as const;

/**
 * Get the UI component for a specific variant
 * Falls back to DEFAULT variant if not found
 */
export const getVariantComponent = (variant: BoosterVariant): VariantComponent => {
  return VARIANT_COMPONENTS[variant] || VARIANT_COMPONENTS[BoosterVariant.DEFAULT];
};

// Re-export variant types for convenience
export { BoosterVariant } from "./BoosterVariant.types";
